// extracted by mini-css-extract-plugin
module.exports = {"desktopFilter":"styles_desktopFilter__cqqmD","module":"styles_module__1DYz9"};